import { render, staticRenderFns } from "./ElementScalePayTableColumn.vue?vue&type=template&id=4c0bea32&scoped=true"
import script from "./ElementScalePayTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScalePayTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0bea32",
  null
  
)

export default component.exports